import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore, createTransform } from "redux-persist";

import authReducer from "./features/auth/authSlice";
import cartReducer from "./features/cart/cartSlice";
import loadingReducer from "./features/loading/loadingSlice";
import historyReducer from "./features/search/historySlice";

// Custom Transform for cart expiration (1 day)
const cartExpirationTransform = createTransform(
  // Called before saving to storage
  (inboundState) => ({
    ...inboundState,
    savedAt: Date.now(),
  }),
  (outboundState) => {
    const oneDay = 240 * 60 * 60 * 1000;
    if (Date.now() - outboundState.savedAt > oneDay) {
      console.log("🕒 Cart expired — clearing persisted cart");
      return { items: [] }; // reset your cart slice
    }
    return outboundState;
  },
  { whitelist: ["cart"] }
);

// Persist configs
const authPersistConfig = {
  key: "auth",
  storage,
};

const cartPersistConfig = {
  key: "cart",
  storage,
  transforms: [cartExpirationTransform], // 👈 add here
};

const historyPersistConfig = {
  key: "history",
  storage,
};

// Wrap reducers
const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);
const persistedCartReducer = persistReducer(cartPersistConfig, cartReducer);
const persistedHistoryReducer = persistReducer(historyPersistConfig, historyReducer);

// Configure store
export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    cart: persistedCartReducer,
    history: persistedHistoryReducer,
    loading: loadingReducer,
  },
});

export const persistor = persistStore(store);
